import clsx from "clsx";
import { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { MetaTagHeader, LoadingAnimation } from "@components";

export default function Dashboard() {
    const [loading, setLoading] = useState(true);
    const [token, setToken] = useState(localStorage.getItem("token") || "");

    const { user } = useAuth0();
    const iframeRef = useRef(null);
    const location = useLocation();

    useEffect(() => {
        const stored = localStorage.getItem("token");
        if (stored !== token) {
            setToken(stored);
        }
    }, []);

    useEffect(() => {
        if (iframeRef.current && user && location && token) {
            iframeRef.current.src = iframeSrc;
        }
    }, [user, location, token]);

    const params = new URLSearchParams(location.hash.slice(1)); // slice removes the "#"
    const queryParams = new URLSearchParams({
        user: user ? JSON.stringify(user) : "",
        pathname: location.pathname || "",
        lat: params.get("lat") || "",
        long: params.get("long") || "",
        token: token || "",
    });

    const iframeSrc = `${process.env.REACT_APP_PROJECT_ANALYSIS_URL}/explorer#${queryParams.toString()}`;

    return (
        <>
            {/* HEADER */}
            <MetaTagHeader />
            {/* TEXT IMG BEATS */}
            <div className={parentContainer}>
                {loading && <LoadingAnimation />}
                {token && (
                    <iframe
                        title="dashboard"
                        src={iframeSrc}
                        ref={iframeRef}
                        className={loading ? "" : "h-full w-full"}
                        onLoad={() => setLoading(false)}
                        allow="clipboard-write"
                    />
                )}
            </div>
        </>
    );
}

const parentContainer = clsx(
    "absolute z-50 flex h-screen w-screen items-center justify-center bg-white",
);
